import React from 'react'

const NewEyeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 11 7" fill="none">
      <path d="M5.38708 0C3.32856 0 1.46179 1.10213 0.0843022 2.89227C-0.0281007 3.03894 -0.0281007 3.24383 0.0843022 3.39049C1.46179 5.1828 3.32856 6.28492 5.38708 6.28492C7.44559 6.28492 9.31237 5.1828 10.6899 3.39265C10.8023 3.24599 10.8023 3.04109 10.6899 2.89443C9.31237 1.10213 7.44559 0 5.38708 0ZM5.53474 5.35534C4.16828 5.43946 3.03984 4.33733 3.12579 2.99796C3.19632 1.89367 4.11097 0.9986 5.23941 0.929582C6.60588 0.845467 7.73432 1.94759 7.64836 3.28697C7.57563 4.38909 6.66098 5.28417 5.53474 5.35534ZM5.46642 4.33302C4.73029 4.37831 4.12199 3.78519 4.17048 3.06482C4.20795 2.46954 4.70164 1.98857 5.30994 1.94975C6.04607 1.90446 6.65437 2.49758 6.60588 3.21795C6.56621 3.81538 6.07252 4.29635 5.46642 4.33302Z" fill="currentColor"/>
    </svg>
  )
}

export default NewEyeIcon
